import styled from 'styled-components'

export const InvoiceSheetContainer = styled.div`
	visibility: hidden;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
`
InvoiceSheetContainer.displayName = 'InvoiceSheetContainer'

export const InvoiceSheetWrap = styled.div`
	position: relative;
	width: 740px;
	font-size: 11.39px;
`
InvoiceSheetWrap.displayName = 'InvoiceSheetWrap'
